declare var lightGallery: any;
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import "src/assets/js/lightgallery.min.js";
import "src/assets/js/lg-video.min.js";
import "src/assets/js/lg-thumbnail.min.js";
import "src/assets/js/froogaloop2.min.js";
import "src/assets/js/lg-zoom.min.js";

@Component({
	selector      : 'app-photos-videos',
	templateUrl   : './photos-videos.component.html',
	encapsulation : ViewEncapsulation.None
})

export class PhotosVideosComponent implements OnInit {
	public flickr_config : SwiperConfigInterface = {
		direction: 'horizontal',
		slidesPerView: 3.3,
		navigation: true,
		spaceBetween: 20,
		breakpoints : {
			767: {
				slidesPerView: 2.2,
				spaceBetween: 10,
			},
			575: {
				slidesPerView: 1.2,
				spaceBetween: 10
			}
		}
	};
	public vimeo_config : SwiperConfigInterface = {
		direction: 'horizontal',
		slidesPerView: 2.8,
		navigation: true,
		spaceBetween: 20,
		breakpoints : {
			767: {
				slidesPerView: 2.2,
				spaceBetween: 10,
			},
			575: {
				slidesPerView: 1.2,
				spaceBetween: 10
			}
		}
	};
	public youtube_config : SwiperConfigInterface = {
		direction: 'horizontal',
		slidesPerView: 2.8,
		navigation: true,
		spaceBetween: 20,
		breakpoints : {
			767: {
				slidesPerView: 2.2,
				spaceBetween: 10,
			},
			575: {
				slidesPerView: 1.2,
				spaceBetween: 10
			}
		}
	};

	@Input() photosVideosData : any;
	@Input() flickreData      : any;
	@Input() youtubeData      : any;
	@Input() vimeoData        : any;

	ngOnInit() {}

	loadGallery( ctype: string ) {
		if ( 'flickr' == ctype ) {
			lightGallery(document.getElementById( 'flickrgallery' ), {
				thumbnail           : true,
				download            : false,
				swipeThreshold      : 100,
				closable            : false,
			});
		}
		if ( 'vimeo' == ctype ) {
			lightGallery(document.getElementById( 'vimeogallery' ), {
				thumbnail         : true,
				loop              : false,
				vimeoPlayerParams : {
					 byline   : 0,
					 portrait : 0,
					 color    : 'CCCCCC',
			    },
			    videojsOptions : {
			    	controls : false,
			    	autoplay : true,
			    	preload  : 'auto',
			    }
			});
		}
		if ( 'youtube' == ctype ) {
			lightGallery(document.getElementById( 'youtubegallery' ), {
				thumbnail           : true,
				loop                : false,
				youtubePlayerParams : {
					controls       : 1,
					autoplay       : 1,
					modestbranding : 0,
					showinfo       : 0,
				}
			});
		}
	}
}